import React from 'react';
import './FindingCard.css';

const CATEGORY_LABEL = {
  beat_drop: 'Plan point not delivered',
  promise_break: 'Payoff not delivered',
  secret_leak_stated: 'States a secret',
  secret_leak_implied: 'Implies a secret',
  purpose_leak: 'Reveals a planted purpose',
  constraint_violation: 'Breaks a story rule',
  fact_drift: 'Contradicts a fact',
};

function categoryLabel(stage, explanation) {
  for (const [key, label] of Object.entries(CATEGORY_LABEL)) {
    if ((stage || '').includes(key) || (explanation || '').toLowerCase().includes(key.replace(/_/g, ' '))) return label;
  }
  return stage || 'Finding';
}

/**
 * One finding's anatomy (Unit 4 build spec §D2): category, quote, plain
 * explanation, Agree/Overrule. Advisory findings are visually and
 * verbally distinct — advice framing, no ruling demanded (design brief
 * §3: "Advisory findings are always labeled as advice, never as errors").
 * Overruled findings stay in place, dimmed, "Overruled by you."
 */
export default function FindingCard({ finding, advisory, ruling, onHover, onLeave, onRule, disabled }) {
  const isOverruled = ruling === 'overrule';
  const isAgreed = ruling === 'agree';
  return (
    <div
      className={`er-finding${isOverruled ? ' er-finding--overruled' : ''}${isAgreed ? ' er-finding--agreed' : ''}${advisory ? ' er-finding--advisory' : ''}`}
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
    >
      <div className="er-finding__head">
        <span className={`er-finding__dot er-finding__dot--${(finding.stage || 'x').replace(/[^a-z_]/g, '')}`} aria-hidden="true" />
        <span className="er-finding__category">{advisory ? 'Advisory' : categoryLabel(finding.stage, finding.explanation)}</span>
      </div>
      {finding.quote && (
        <blockquote className="er-finding__quote">&ldquo;{finding.quote}&rdquo;</blockquote>
      )}
      <p className="er-finding__explanation">{finding.explanation}</p>
      {advisory ? (
        <p className="er-finding__advice-note">One inspector&rsquo;s read — not a ruling you need to make.</p>
      ) : (
        <div className="er-finding__actions">
          <button
            type="button"
            className={`er-finding__act${isAgreed ? ' er-finding__act--agree-active' : ''}`}
            disabled={disabled}
            onClick={() => onRule(finding.id, 'agree')}
          >
            Agree
          </button>
          <button
            type="button"
            className={`er-finding__act${isOverruled ? ' er-finding__act--overrule-active' : ''}`}
            disabled={disabled}
            onClick={() => onRule(finding.id, 'overrule')}
          >
            Overrule
          </button>
          <span className="er-finding__status">
            {isAgreed && 'Marked for regeneration'}
            {isOverruled && 'Overruled by you'}
          </span>
        </div>
      )}
    </div>
  );
}
